import React, { Fragment } from "react";
import DadataSearch from "../../../../Authorization/containers/DadataSearch/dadataSearch";
import { AutoSearchFields } from "./AutoSearchFields";
import { OtherFields } from "./OtherFields";
import { Form, Radio } from "antd";

const AddLicenceeFields = ({ form, handleFieldsChange, data }) => {
  const { getFieldDecorator } = form;
  const handleChange = val => {
    val && handleFieldsChange(val);
  };

  return (
    <div className="add-licensee__form" style={{ marginBottom: 16 }}>
      <div className="add-licensee__item" hidden>
        <span className="label">Лицензиат:</span>
        <Form.Item>
          {getFieldDecorator("subjectKey")(
            <Radio.Group>
              <Radio value="legal">Юридическое лицо</Radio>
              <Radio value="individ">ИП</Radio>
            </Radio.Group>
          )}
        </Form.Item>
      </div>
      <Fragment>
        <div className="add-licensee__item__ur-group visible">
          <div className="add-licensee__item">
            <DadataSearch
              form={form}
              style={{ width: 368 }}
              label={<span className="label">{"Перевозчик:"}</span>}
              handleChange={handleChange}
            />
          </div>
          {data && Object.keys(data).length > 2 && (
            <>
              <AutoSearchFields form={form} />
              <OtherFields form={form} />
            </>
          )}
        </div>
      </Fragment>
    </div>
  );
};

export default AddLicenceeFields;
